// extracted by mini-css-extract-plugin
module.exports = {"component":"ButtonIcon_component__1A83_"};